var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 8.00004C1.33301 4.31814 4.31777 1.33337 7.99967 1.33337C11.6815 1.33337 14.6663 4.31814 14.6663 8.00004C14.6663 11.6819 11.6815 14.6667 7.99967 14.6667C4.31777 14.6667 1.33301 11.6819 1.33301 8.00004ZM10.7167 5.28817C11.0178 5.50006 11.0901 5.91593 10.8782 6.21703L7.71154 10.717C7.59507 10.8825 7.40981 10.9862 7.20787 10.9988C7.00587 11.0114 6.80914 10.9316 6.67307 10.7818L5.00638 8.94851C4.75871 8.67604 4.77879 8.25444 5.05123 8.00677C5.32366 7.75911 5.74529 7.77917 5.99297 8.05157L7.09994 9.26931L9.78781 5.44971C9.99967 5.1486 10.4155 5.07628 10.7167 5.28817Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBlack);
export default __webpack_public_path__ + "static/media/checkCircleBlack.c7c47caae016ea1f2b956f659643f7f7.svg";
export { ForwardRef as ReactComponent };